import useOmsenApiClient from "./clients/useOmsenApiClient";
import { useQuery } from "@tanstack/react-query";

export default function useOmsenTaxDomiciles() {
  const client = useOmsenApiClient();

  const getOmsenTaxDomiciles = async () => {
    const response = await client.apiOmsenTaxdomicilesGet();
    return response.data;
  };

  return useQuery(["omsenTaxDomiciles"], getOmsenTaxDomiciles, {
    refetchOnWindowFocus: false,
    refetchOnMount: false
  });
}
